import {
  HttpInterceptorFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { RequestMapperService } from '../services/request-mapper.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from '../services/toast-service.service';
import { SILENT } from './silent.token';

interface JwtPayload {
  exp: number;
}

let activeRequests = 0;

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const http = inject(HttpClient);
  const spinner = inject(NgxSpinnerService);
  const toast = inject(ToastService);

  const isSilent = req.context.get(SILENT);

  if (!isSilent && activeRequests === 0) spinner.show();
  if (!isSilent) activeRequests++;

  const token = typeof window !== 'undefined' && localStorage && localStorage.getItem('authToken') ? localStorage.getItem('authToken') : '';
  // const refreshToken = localStorage.getItem('refreshToken') || '';

  const isTokenExpired = (jwt: string): boolean => {
    try {
      const decoded = jwtDecode<JwtPayload>(jwt);
      return decoded.exp < Math.floor(Date.now() / 1000);
    } catch {
      return true;
    }
  };

  // Attach Authorization header if token exists and not expired
  if (token && !isTokenExpired(token)) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const message =
        err.error?.message ||
        err.error?.error ||
        err.message ||
        `HTTP ${err.status}`;

      // 🚨 Handle 401/403 even when token exists
      if ((err.status === 401 || err.status === 403) && token) {
        toast.error(
          err.error?.message ||
            'Session expired or logged in from another device. Please login again.'
        );

        // Clear tokens
        localStorage.clear();

        // Redirect to login
        router.navigate([`${RequestMapperService.AUTH_URL}`]);
      }
      // Optional: Redirect out of exam if current route starts with /exam
      else if (router.url.startsWith('/exam')) {
        router.navigate([
          `${RequestMapperService.EXAM_URL}/${RequestMapperService.LIST_URL}`,
        ]);
      }
      // Show toast for other non-auth errors
      else if (![401, 403].includes(err.status)) {
        toast.error(message);
      }

      return throwError(() => err);
    }),
    finalize(() => {
      if (!isSilent) {
        activeRequests--;
        if (activeRequests === 0) spinner.hide();
      }
    }),
  );
};
